import apiEnergy from '@/services/apiEnergy'

const state = {
  current: {},
  authStatus: {},
  notifications: {
    api: {},
    energydata: {},
  },
  storedRestrictions: [],
  apiEnergy: {
    user: {},
  },
}
const actions = {
  login({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      this._vm.$auth
        .login({
          data: {
            email: data.username,
            password: data.password,
          },
          //redirect: { name: 'dashboard' }
        })
        .then((res) => {
          dispatch('setLogged')
          apiEnergy.authenticate(data.username, data.password).then((res) => {
            dispatch('setApiEnergyUser', res.data)
          })
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  initApi({ dispatch }) {
    apiEnergy.setToken()
    apiEnergy.me().then((res) => {
      dispatch('setApiEnergyUser', res.data)
    })
  },
  setUser({ commit }, data) {
    commit('SET_USER', data)
  },
  setAuthStatus({ commit, getters }, data) {
    commit('SET_AUTH_STATUS', getters['isLoggedIn'] ? {} : data)
  },
  setApiEnergyUser({ commit }, data) {
    commit('SET_API_ENERGY_USER', data)
  },
  setLogged({ commit }) {
    commit('SET_USER', this._vm.$auth.user() || {})
  },
  logout({ commit }, makeRequest = false) {
    commit('SET_USER', {})
    this._vm.$auth.logout({
      makeRequest: makeRequest,
    })
    apiEnergy.removeToken()
  },
  fetchNotifications({ commit, getters }) {
    if (getters['isLoggedIn']) {
      this._vm.$api.get('bg/get_unread').then((res) => {
        commit('NOTIFICATIONS', {
          api: res ? res.data : {},
        })
      })
      this._vm.$api.get('bg/get_today_downloads').then((res) => {
        commit('NOTIFICATIONS', {
          energydata: res ? res.data : {},
        })
      })
    }
  },
  copyRestrictions({ commit }, data) {
    commit('STORE_RESTRICTIONS', data)
    setTimeout(() => {
      commit('STORE_RESTRICTIONS', [])
    }, 60000)
  },
}

const mutations = {
  SET_USER(state, payload) {
    state.current = payload
  },
  SET_AUTH_STATUS(state, payload) {
    state.authStatus = payload
  },
  SET_API_ENERGY_USER(state, payload) {
    state.apiEnergy.user = payload
  },
  NOTIFICATIONS(state, payload) {
    Object.assign(state.notifications, payload)
  },
  STORE_RESTRICTIONS(state, payload) {
    state.storedRestrictions = [...payload]
  },
}

const getters = {
  get: (state) => state.current,
  getApiEnergyUser: (state) => state.apiEnergy.user,
  isLoggedIn: (state) => !!Object.keys(state.current).length,
  isAdmin: (state, getters) => {
    return getters.isLoggedIn ? getters.is('admin') : false
  },
  can: (state, getters) => (value) => {
    if (!getters.isLoggedIn) {
      return false
    }
    let permissions = state.current.allPermissions
    let _return = false
    if (!Array.isArray(permissions)) {
      return false
    }
    if (value.includes('|')) {
      value.split('|').forEach(function (item) {
        if (permissions.includes(item.trim())) {
          _return = true
        }
      })
    } else if (value.includes('&')) {
      _return = true
      value.split('&').forEach(function (item) {
        if (!permissions.includes(item.trim())) {
          _return = false
        }
      })
    } else {
      _return = permissions.includes(value.trim())
    }
    return _return
  },
  is: (state, getters) => (value) => {
    if (!getters.isLoggedIn) {
      return false
    }
    let roles = state.current.allRoles
    let _return = false
    if (!Array.isArray(roles)) {
      return false
    }
    if (value.includes('|')) {
      value.split('|').forEach(function (item) {
        if (roles.includes(item.trim())) {
          _return = true
        }
      })
    } else if (value.includes('&')) {
      _return = true
      value.split('&').forEach(function (item) {
        if (!roles.includes(item.trim())) {
          _return = false
        }
      })
    } else {
      _return = roles.includes(value.trim())
    }
    return _return
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
